import React from "react";

/**
 * Fixed decorative background for the entire site.
 * Layers (bottom → top): base cream, line grid, fine dots, soft orbs, grain.
 * All non-interactive; sits under all content.
 */
export default function SiteBackground() {
  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      data-testid="site-background"
    >
      {/* Coarse line grid */}
      <div
        className="absolute inset-0 bg-grid-lines"
        style={{
          WebkitMaskImage:
            "radial-gradient(ellipse 70% 55% at 50% 30%, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0) 100%)",
          maskImage:
            "radial-gradient(ellipse 70% 55% at 50% 30%, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0) 100%)",
        }}
      />

      {/* Fine dot grid — extra texture */}
      <div
        className="absolute inset-0 dot-grid-fine opacity-60"
        style={{
          WebkitMaskImage:
            "radial-gradient(ellipse 60% 50% at 50% 20%, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%)",
          maskImage:
            "radial-gradient(ellipse 60% 50% at 50% 20%, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%)",
        }}
      />

      {/* Warm orbs — drifting */}
      <div className="orb orb-yellow animate-float-slow w-[520px] h-[520px] -top-24 -left-32" />
      <div className="orb orb-peach animate-float-slow-alt w-[460px] h-[460px] top-[40vh] -right-40 opacity-40" />
      <div className="orb orb-mint animate-float-slow w-[380px] h-[380px] top-[110vh] left-[20vw] opacity-35" />

      {/* Grain */}
      <div className="absolute inset-0 noise-overlay" />
    </div>
  );
}
